<template>
    <v-container class="container-view mx-auto">
        <v-row class="d-flex justify-center white--text">
            <h1>Votos Emitidos</h1>
        </v-row>
        <v-row class="d-flex justify-center">
            <v-col>
                <table class="table-filters" width="100%">
                    <tbody>
                        <tr>
                            <td width="20%">
                                Elecciones
                            </td>
                            <td width="80%">
                                <v-select
                                    v-model="electionIdSelected"
                                    :item-text="textItemElection"
                                    :items="elecciones"
                                    :loading="loading"
                                    item-value="id"
                                    label="Selecciona elección"
                                    @change="onChangeElection"
                                >
                                </v-select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Centros / SEMS
                            </td>
                            <td>
                                <v-select
                                    v-model="centerSelected"
                                    :item-text="textItemCenter"
                                    :items="centers"
                                    :loading="loading"
                                    item-value="centro"
                                    label="Selecciona centro / SEMS"
                                    @change="onChangeCenter"
                                >
                                </v-select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Divisiones / Escuelas
                            </td>
                            <td>
                                <v-autocomplete
                                    v-model="uresSelected"
                                    :disabled="uresList.length === 0"
                                    :item-text="textItemUres"
                                    :items="uresList"
                                    :loading="loading"
                                    item-value="ures_pred"
                                    label="Selecciona División / Escuela"
                                    @change="onChangeUres"
                                >
                                </v-autocomplete>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="prp-table-container">
                    <scale-loader
                        v-if="loading"
                        class="prp-table-loader"
                        color="black"
                    ></scale-loader>
                    <apexchart
                        class="chart-pie"
                        type="pie"
                        width="50%"
                        :options="chartOptions"
                        :series="series"
                        v-if="series.length > 0"
                    ></apexchart>
                    <div v-else style="height: 200px"></div>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        Total Votantes
                                    </th>
                                    <th class="text-center">
                                        Total Faltantes
                                    </th>
                                    <th class="text-center">
                                        Total
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in votes" :key="index">
                                    <td>{{ item.total_yes }}</td>
                                    <td>{{ item.total_no }}</td>
                                    <td>{{ item.total }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col
                v-for="ocg in ocgs"
                :key="ocg.id"
                class="d-flex px-1 align-center"
                cols="12"
                md="6"
            >
                <votesEmitted v-bind:ocg="ocg"></votesEmitted>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { mapGetters } from 'vuex';
import FileDownload from 'js-file-download';
import { DateTime } from 'luxon';
import VueApexCharts from 'vue-apexcharts';
import votesEmitted from '../components/votesEmitted';

export default {
    name: 'votos-emitidos',
    components: {
        ScaleLoader,
        apexchart: VueApexCharts,
        votesEmitted,
    },
    props: {
        sizes: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
        }),
    },
    data: () => {
        return {
            ocgs: [],
            showfirst: false,
            title: '',
            loading: false,
            series: [],
            uresList: [],
            centers: [],
            electionIdSelected: '',
            centerSelected: '',
            uresSelected: '',
            list: [],
            search: '',
            headers: [
                {
                    text: 'Eleccion',
                    value: 'desc_eleccion',
                },
                {
                    text: 'Ures',
                    value: 'ures',
                },
            ],
            votes: [],
            chartOptions: {
                chart: {
                    width: 380,
                    type: 'pie',
                },
                colors: ['#2E93fA', '#90BBD8'],
                labels: ['Votantes', 'Faltantes'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200,
                            },
                            legend: {
                                position: 'bottom',
                            },
                        },
                    },
                ],
            },
        };
    },
    methods: {
        onChangeElection: function() {
            this.uresList = [];
            this.uresSelected = '';
            if (this.electionIdSelected) {
                this.loadCenters();
                this.loadUres();
                this.generateTable();
            }
        },
        onChangeCenter: function() {
            this.uresList = [];
            this.uresSelected = '';

            let txt = this.centers.find(e => {
                return e.centro === this.centerSelected;
            });
            this.title = txt.desc_centro;

            this.loadUres();
            this.generateTable();
        },
        onChangeUres: function() {
            if (!this.electionIdSelected) {
                return;
            }

            let txt = this.uresList.find(e => {
                e.ures_pred === this.uresSelected;
                return e.ures_pred;
            });
            this.title = txt.desc_ures_pred;

            this.generateTable();
        },
        loadCenters: function() {
            this.$store
                .dispatch('prep/getCenters', {
                    election_id: this.electionIdSelected,
                })
                .then(res => {
                    if (res.length) {
                        res.unshift({
                            centro: '',
                            desc_centro: 'TODOS LOS CENTROS',
                        });
                    }
                    this.centers = res;
                });
        },
        loadUres: function() {
            this.$store
                .dispatch('prep/getUresByIdElection', {
                    election_id: this.electionIdSelected,
                    center_id: this.centerSelected,
                })
                .then(res => {
                    if (res.length) {
                        res.unshift({
                            ures_pred: '',
                            desc_ures_pred: 'TODOS LOS URES',
                        });
                    }
                    this.uresList = res;
                });
        },
        generateTable: function() {
            const filters = {
                election_id: this.electionIdSelected,
                center_id: this.centerSelected,
                ures: this.uresSelected,
            };

            this.loading = true;
            this.$store
                .dispatch('prep/getVotesEmitted', filters)
                .then(res => {
                    if (res) {
                        this.ocgs = res.data;
                        if (this.ocgs.length === 0) {
                            this.showfirst = true;
                        } else {
                            this.showfirst = false;
                        }

                        let total_yes = 0;
                        let total_no = 0;

                        if (res.series) {
                            this.series = res.series;
                            total_yes = new Intl.NumberFormat('es-MX').format(
                                res.series[0]
                            );
                            total_no = new Intl.NumberFormat('es-MX').format(
                                res.series[1]
                            );
                        }
                        this.votes = [
                            {
                                total_yes,
                                total_no,
                                total: new Intl.NumberFormat('es-MX').format(
                                    res.total
                                ),
                            },
                        ];
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        downloadCSV: function() {
            this.$store
                .dispatch('prep/getPlanillasCSV', {
                    election_id: this.electionIdSelected,
                })
                .then(res => {
                    const eleccion = this.elecciones.find(
                        eleccion => eleccion.id === this.electionIdSelected
                    );

                    if (eleccion) {
                        const type =
                            eleccion.type.charAt(0).toUpperCase() +
                            eleccion.type.slice(1);
                        const fileName = `${
                            eleccion.id
                        }Planillas${type}-${DateTime.now().toFormat(
                            'dd-MM-yyyy'
                        )}`;
                        const data = new Blob([res.csv], { type: 'text/csv' });
                        FileDownload(data, fileName + '.csv');
                    }
                });
        },
        textItemElection: item => {
            const type = item.type || '';
            return `${item.id} - ${item.description} | ${type.toUpperCase()}`;
        },
        textItemCenter: item =>
            item.desc_centro + (item.centro ? ' | ' + item.centro : ''),
        textItemUres: item =>
            item.desc_ures_pred +
            (item.ures_pred ? ' | ' + item.ures_pred : ''),
    },
    created() {
        this.$store.dispatch('elecciones/getElecciones');
    },
};
</script>

<style lang="scss">
.prp-container {
    padding: 1rem;
}

.prp-title {
    text-align: center;
    margin-bottom: 2rem;
}

.prp-home-back {
    cursor: pointer;
    position: absolute;
}

.prp-table-container {
    position: relative;
    border-radius: 0.5rem;
    margin-top: 1.5rem;
    padding: 1rem;
    width: 100%;
    background-color: #fff;
}

.prp-table-loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.chart-pie {
    .apexcharts-canvas {
        margin: auto;
    }
}

.table-filters {
    background-color: #fff;
    border-collapse: collapse;
    padding: 1rem;
    border-radius: 0.5rem;

    tr:first-child td {
        border-top: 0;
    }

    tr td:first-child {
        border-left: 0;
    }

    tr:last-child td {
        border-bottom: 0;
    }

    tr td:last-child {
        border-right: 0;
    }

    td {
        border: 1px solid $votex-gray-background;
        color: $votex-background-primary;

        select {
            width: 100%;
        }
    }
}
</style>
